import http from '../plugins/axios'

export const getAllSummaries = async () => {
  try {
    const response = await http.get(`summaries/all`)
    return response.data
  } catch(error) {
    throw error
  }
}